import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { tap } from  'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(public auth: AuthenticationService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
 		return new Promise((resolve) => {
      		this.auth.isLoggedIn()
        		.then((isLogged: boolean) => {
          			if (isLogged) {
          				resolve(true);
          				return true;
          			}
          			this.router.navigate(['/login']);
          			resolve(false);
          			return false;
        		})
        		.catch(err => {
   					this.router.navigate(['/login']);
        			resolve(false);
        			return false;
        		});
      });
  }

}